export default "__VITE_ASSET__DmQg$gV7__"